import axios from "axios";

const ENV_BASE = process.env.REACT_APP_BACKEND_URL;

// When the app is opened on its own custom domain (https, different host than the configured backend URL),
// call the API on the page's own origin: the platform routes /api on every attached domain, and this avoids
// cross-origin preflights and third-party cookie blocking.
const pickApiOrigin = () => {
  if (typeof window === "undefined" || window.location.protocol !== "https:") return ENV_BASE;
  try {
    return new URL(ENV_BASE).host === window.location.host ? ENV_BASE : window.location.origin;
  } catch {
    return window.location.origin;
  }
};

export const API = `${pickApiOrigin()}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (e) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export default api;
